export default __webpack_public_path__ + "static/media/GridItemPurposes.2c865972.png";